import React from "react";

const WhyChooseUsSection = () => {
  // Array of features for clean management
  const features = [
    {
      id: 1,
      title: "Low Latency for Gaming",
      desc: "Ping times under 10ms means no lag. Play your favorite online games without any delay or disconnection.",
      icon: "🎮",
    },
    {
      id: 2,
      title: "Unlimited Data Usage",
      desc: "Stream, download, and browse as much as you want. We never throttle speeds or impose data caps on your plan.",
      icon: "∞",
    },
    {
      id: 3,
      title: "99.9% Network Uptime",
      desc: "Our fiber-optic infrastructure ensures you stay connected when it matters most. Always on, always fast.",
      icon: "🛡️",
    },
    {
      id: 4,
      title: "Advanced Security",
      desc: "Built-in firewall and DDOS protection to keep your devices and personal data safe from online threats.",
      icon: "🔒",
    },
    {
      id: 5,
      title: "Free Installation",
      desc: "Our professional team comes to your home or office, sets up the router, and ensures everything works perfectly.",
      icon: "🛠️",
    },
    {
      id: 6,
      title: "24/7 Customer Support",
      desc: "Having trouble? Our expert support team is available around the clock via chat, phone, or email.",
      icon: "🎧",
    },
  ];

  return (
    <section className="py-24 bg-white text-slate-900">
      <div className="container mx-auto px-6 max-w-screen-xl">
        {/* --- Section Header --- */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-blue-600 font-bold tracking-wider uppercase text-xs">
            Why Us
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-6 text-slate-900">
            Connection You Can <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-600">
              Count On
            </span>
          </h2>
          <p className="text-lg text-slate-600">
            We don't just sell internet; we sell reliability. Our network is
            built for speed, security, and stability.
          </p>
        </div>

        {/* --- Features Grid --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <FeatureCard key={feature.id} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

// --- Reusable Feature Card Component ---
const FeatureCard = ({ feature }) => (
  <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 hover:border-blue-200 hover:shadow-xl transition-all duration-300 group">
    {/* Large Icon Emoji */}
    <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-3xl mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300">
      {feature.icon}
    </div>

    {/* Title */}
    <h3 className="text-xl font-bold mb-3 text-slate-900 group-hover:text-blue-600 transition-colors">
      {feature.title}
    </h3>

    {/* Description */}
    <p className="text-slate-600 leading-relaxed text-sm">{feature.desc}</p>
  </div>
);

export default WhyChooseUsSection;
